import React, { FC } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./authContext";

export const RequireAuth: FC<{ children: React.ReactNode; role?: "admin" | "user" }> = ({ children, role }) => {
    const { user, loading } = useAuth();
    const loc = useLocation();

    if (loading) return <div>Loading...</div>;
    if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;

    if (role && user.role !== role) return <Navigate to="/unauthorized" replace />;
    return <>{children}</>;
};